module.exports = __webpack_public_path__ + "img/54.full_garbage_can.7eb9968e.svg";